export type VariantState =
  | 'draft' | 'validated' | 'needs_review' | 'approved'
  | 'scheduled' | 'publishing' | 'published' | 'failed'
  | 'canceled' | 'held';

const ALLOWED: Readonly<Record<VariantState, readonly VariantState[]>> = {
  draft: ['validated'],
  validated: ['needs_review', 'draft'],
  needs_review: ['approved', 'draft'],
  approved: ['scheduled', 'draft'],
  scheduled: ['publishing', 'canceled', 'held', 'draft'],
  publishing: ['published', 'failed'],
  published: [],
  failed: ['publishing', 'draft', 'canceled'],
  canceled: ['scheduled', 'draft'],
  held: ['scheduled', 'canceled', 'draft'],
};

export class InvalidTransitionError extends Error {
  constructor(readonly from: VariantState, readonly to: VariantState) {
    super(`Cannot move a variant from ${from} to ${to}`);
    this.name = 'InvalidTransitionError';
  }
}

export const canTransition = (from: VariantState, to: VariantState): boolean =>
  ALLOWED[from].includes(to);

export const transition = (from: VariantState, to: VariantState): VariantState => {
  if (!canTransition(from, to)) throw new InvalidTransitionError(from, to);
  return to;
};
